import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32 0H0V32H32V0Z",
      class: "bg",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.6569 9.3038C24.781 12.3755 24.781 17.3558 21.6569 20.4276L17.7179 24.3004C16.7691 25.2332 15.2309 25.2332 14.2821 24.3004L10.3431 20.4276C7.21895 17.3558 7.21895 12.3755 10.3431 9.3038C13.4673 6.23207 18.5327 6.23207 21.6569 9.3038ZM16.0002 17.387C17.5733 17.387 18.8485 16.1332 18.8485 14.5865C18.8485 13.0399 17.5733 11.786 16.0002 11.786C14.4271 11.786 13.1519 13.0399 13.1519 14.5865C13.1519 16.1332 14.4271 17.387 16.0002 17.387Z",
      class: "primary",
      fill: "#151F6D"
    }, null, -1)
  ])))
}
export default { render: render }